<template>
  <div class="pcr-inner-chart-container mb-3">
    <div :id="plotDivId"></div>
  </div>
</template>

<script>

  import Plotly from 'plotly.js-cartesian-dist'

  export default {
    name: "PCRCheckChartPlotly",
    data: function () {
        return {
          pcrOkColor: "#5cb85c",
          pcrNotOkColor: "#d9534f"
        }
    },
    props: {
      renewalTypeName: String,
      renewalTypeId: String,
      pcrValue: Number,
      pcrIsOk: Boolean,
      maxPcrAllowed: Number,
      minPcrAllowed: Number,
    },
    computed: {
      plotDivId(){
        return this.renewalTypeId + '-pcr-id'
      },
      chartData() {
        return [
          {
            // PCR Valid Range bar
            base: [this.minPcrAllowed],
            x: [this.maxPcrAllowed - this.minPcrAllowed],
            y: [1],
            width: [1],
            name: 'Valid Range Name',
            type: 'bar',
            orientation: 'h',
            marker: {
              color: this.pcrRangeBarFillColor,
              line: {
                color: this.pcrRangeBarLineColor,
                width: 3
              }
            }
          },
          {
            // Actual PCR Line
            base: [0],
            x: [this.pcrValue, this.pcrValue],
            y: [0, 2],
            // width: [0.5],
            type: 'scatter',
            marker: {
              color: 'rgb(25,64,103)'
            }
            // orientation: 'h'
          },
          {
            // PCR Value Text Annotation
            x: [this.pcrValue],
            y: [1],
            text: ["PCR = " + this.pcrValue],
            mode: "markers+text",
            marker: {
              color: 'rgba(0,0,0,0)'
            },
            textposition: (this.pcrValue > 80)? 'left':'right' // Keep text visible
          }
        ]
      },
      chartLayout() {
        return {
          xaxis: {
            range: [0, 100],
            linewidth: 1,
            mirror: true,
            title:{
              text: "Pavement Condition Rating"
            }
          },
          yaxis: {
            linewidth: 1,
            mirror: true,
            showticklabels: false
          },
          height: 120,
          margin: {l: 20, r: 20, b: 40, t: 20},
          barmode: "overlay",
          showlegend: false
        }
      },
      chartOptions(){
        return {
          staticPlot: true,
          responsive: true
        }
      },
      pcrRangeBarFillColor(){
        return this.pcrIsOk ? 'rgba(58,142,67,.6)' : 'rgba(220,53,69,.6)'
      },
      pcrRangeBarLineColor(){
        return this.pcrIsOk ? 'rgb(58,142,67)' : 'rgb(220,53,69)'
      }
    },
    methods: {
      createPlot() {
        Plotly.newPlot(this.plotDivId, this.chartData, this.chartLayout, this.chartOptions)
      },
    },
    mounted() {
      this.createPlot()
    }
  }
</script>

<style scoped>
  /*.pcr-inner-chart-container {*/
    /*height: 4rem;*/
    /*width: 300px;*/
  /*}*/

</style>